var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};



// WEBPACK FOOTER //
// ./~/@babel/polyfill/~/core-js/modules/_has.js